import { Component, OnInit,Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from '../service/access.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-access-incoming-request-confirm',
  templateUrl: './access-incoming-request-confirm.component.html',
  styleUrls: ['./access-incoming-request-confirm.component.css']
})
export class AccessIncomingRequestConfirmComponent implements OnInit {
  @Input()id: string;
  status: any; //any=[];
  idS: string; //any=[];
  type: any
  items:any =[];
  buttonRedirect= false;
  constructor(private route: ActivatedRoute,
              private dataApi: AccessService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog) {
    this.route.snapshot.paramMap.get('id');
    this.id = this.route.snapshot.paramMap.get('id');
  }

  getAccessResult()
  {
    this.spinner.show("loading")
    this.dataApi.getAccessResult(this.id).subscribe((data: any) => {
      this.items=data;
      this.idS=data.RequestNumber;
      this.status= data.status;

      this.type= data.type;
      this.spinner.hide("loading")},
                                                    (err) => {
                                                      this.spinner.hide("loading");
                                                      if(err.error.error !== 'Invalid token.') {
                                                        this.dialog.open(ModErrorComponent, {
                                                          width: 'auto',
                                                          panelClass: 'myapp-no-padding-dialog',
                                                        });
                                                      }
                                                    });
  }

  ngOnInit() {
    this.spinner.show("AccessValidation")
    this.dataApi.getValidatePermision().subscribe(
      (data: any)=>{
        this.spinner.hide("AccessValidation");
        if(data) {
          this.buttonRedirect=true;
          this.getAccessResult()
        }else{
          this.getAccessResult()
          // sessionStorage.clear();
          // window.location.reload();
         }
      },
      (err)=>{
        this.spinner.hide("AccessValidation");

        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
    )

    //this.getAccessResult();
  }

}
